import { createFileRoute } from "@tanstack/react-router"
import Inbox from "~/pages/inbox"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/inbox")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Inbox")

  return <Inbox />
}
